import {
  Component,
  Directive,
  HostBinding,
  ViewEncapsulation,
  booleanAttribute,
  contentChild,
  input
} from '@angular/core';
import { CommonModule } from '@angular/common';

// Marker directives — re-exported so parent templates get them automatically
@Directive({ selector: '[info-card-header]', standalone: true })
export class InfoCardHeaderDirective {}

@Directive({ selector: '[info-card-footer]', standalone: true })
export class InfoCardFooterDirective {}

@Component({
  selector: 'umss-info-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UmssInfoCardComponent {
  @HostBinding('style.display') display = 'contents';

  header = contentChild(InfoCardHeaderDirective);
  footer = contentChild(InfoCardFooterDirective);

  disabled = input(false, { transform: booleanAttribute });
}
